//tron wallet modal provider
import { useMemo } from 'react'

import { WalletError } from '@tronweb3/tronwallet-abstract-adapter'
import { WalletProvider } from '@tronweb3/tronwallet-adapter-react-hooks'
import { WalletModalProvider } from '@tronweb3/tronwallet-adapter-react-ui'
import '@tronweb3/tronwallet-adapter-react-ui/style.css'
import { BitKeepAdapter, OkxWalletAdapter, TokenPocketAdapter, TronLinkAdapter } from '@tronweb3/tronwallet-adapters'

const TronModalProvider = ({ children }: React.PropsWithChildren) => {
    const onError = (error: WalletError) => {
        console.error('Wallet Error:', error)
    }

    const adapters = useMemo(() => {
        const tronLink = new TronLinkAdapter()
        const bitKeep = new BitKeepAdapter()
        const okxWallet = new OkxWalletAdapter()
        const tokenPocket = new TokenPocketAdapter()

        return [tronLink, bitKeep, okxWallet, tokenPocket]
    }, [])

    return (
        <WalletProvider adapters={adapters} onError={onError} autoConnect={false}>
            <WalletModalProvider>{children}</WalletModalProvider>
        </WalletProvider>
    )
}

export default TronModalProvider
